/**
 * z-index de overlays (mayor = encima). Un solo lugar para no invertir capas al agregar modales.
 * Valores alineados al orden previo en Tailwind (retrocompatible).
 */
export const MLV_Z = Object.freeze({
  feedFullscreen: 95,
  mercadoPago: 100,
  guestAuth: 200,
  pubExitoBanners: 220,
  pubListoToast: 240,
  ventaCelebracion: 250,
  miniModal: 260,
  compradorTag: 270,
  limitePub: 280,
  /** Por encima del modal de límite / publicar; debajo de notificaciones y calificar. */
  negocioExplainer: 282,
  notifResena: 285,
  calificarVendedor: 290,
  navErrorToast: 300,
});

/** @param {HTMLElement | null} el */
export function mlvApplyZ(el, key) {
  if (el && MLV_Z[key] != null) el.style.zIndex = String(MLV_Z[key]);
}
